<template>
  <Modal ref="modal" title="Detalhes da Baixa Manual" @cancel="close">
    <div v-if="baixa" class="baixa-details">
      <div class="info-row">
        <span class="label">Usuário responsável:</span>
        <span>{{ baixa.usuario }}</span>
      </div>
      <div class="info-row">
        <span class="label">Data/Hora da baixa:</span>
        <span>{{ formatarData(baixa.data_baixa) }}</span>
      </div>
      <div class="info-row">
        <span class="label">Motivo:</span>
        <span>{{ baixa.motivo }}</span>
      </div>
      <div class="info-row">
        <span class="label">Boleto Original:</span>
        <Button 
          v-if="baixa.boleto_original_base64" 
          text="Visualizar arquivo" 
          color="secondary" 
          @handle:click="visualizarArquivo(baixa.boleto_original_base64, 'Boleto Original')"
          class="file-button">
          <FileOutline :size="16" />
        </Button>
        <span v-else class="no-file">Arquivo não disponível</span>
      </div>
      <div class="info-row">
        <span class="label">Comprovante de Pagamento:</span>
        <Button 
          v-if="baixa.comprovante_pagamento_base64" 
          text="Visualizar arquivo" 
          color="secondary" 
          @handle:click="visualizarArquivo(baixa.comprovante_pagamento_base64, 'Comprovante de Pagamento')"
          class="file-button">
          <FileOutline :size="16" />
        </Button>
        <span v-else class="no-file">Arquivo não disponível</span>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from 'core/Modal'
import Button from 'core/Button'
import FileOutline from 'icons/FileOutline'

export default {
  name: 'VisualizarBaixaManualModal',
  components: { 
    Modal,
    Button,
    FileOutline 
  },
  props: {
    baixa: Object,
  },
  methods: {
    open() {
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
    },
    formatarData(data) {
      if (!data) return ''
      return new Date(data).toLocaleString('pt-BR')
    },
    visualizarArquivo(base64Data, titulo) {
      if (!base64Data) {
        this.$toasted.show('Arquivo não disponível.', {
          position: 'top-right',
        })
        return
      }

      try {
        // Criar um blob a partir do base64
        const byteCharacters = atob(base64Data)
        const byteNumbers = new Array(byteCharacters.length)
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        
        // Detectar o tipo de arquivo pelo cabeçalho
        let mimeType = 'application/pdf'
        if (base64Data.startsWith('/9j/')) {
          mimeType = 'image/jpeg'
        } else if (base64Data.startsWith('iVBORw0KGgo')) {
          mimeType = 'image/png'
        }
        
        const blob = new Blob([byteArray], { type: mimeType })
        const url = URL.createObjectURL(blob)
        
        // Abrir em nova aba
        window.open(url, '_blank')
        
        // Limpar a URL após um tempo para liberar memória
        setTimeout(() => URL.revokeObjectURL(url), 1000)
        
      } catch (error) {
        console.error('Erro ao processar arquivo:', error)
        this.$toasted.show('Erro ao abrir o arquivo.', {
          position: 'top-right',
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.baixa-details {
  min-width: 30vw;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.info-row {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
  align-items: flex-start;
}

.label {
  font-weight: 600;
  color: #1C2D5A;
  min-width: 180px;
}

.file-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.no-file {
  color: #888;
  font-style: italic;
}
</style>
